var exports = {
  "pC": "thinking___ArGBg",
};

module.exports = exports;
